export const UPDATE_AVALIACOES = 'UPDATE_AVALIACOES';
export const ADD_AVALIACOES = 'ADD_AVALIACOES';
export const SET_AVALIACOES = 'SET_AVALIACOES';
export const REMOVE_AVALIACOES = 'REMOVE_AVALIACOES';
export const SET_AVALIACAO = 'SET_AVALIACAO';